import React, { forwardRef } from "react";
import { cx } from "@/utils/cx";
import { Icons } from "@/assets";

interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  error?: string; // <-- Added to display validation errors
}

export const Checkbox = forwardRef<HTMLDivElement, CheckboxProps>(({
  checked = false,
  onChange,
  label,
  className,
  disabled = false,
  error
}, ref) => {

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) return;
    e.stopPropagation(); // Prevent bubbling if used inside other clickable elements
    onChange?.(!checked);
  };

  return (
    <div className="flex flex-col gap-1.5">
      <div
        ref={ref}
        onClick={handleClick}
        className={cx(
          "flex items-center gap-3 cursor-pointer select-none group",
          disabled && "opacity-50 cursor-not-allowed",
          className
        )}
      >
        {/* Box */}
        <div
          className={cx(
            "w-4 h-4 rounded-[4px] border-[1.6px] flex items-center justify-center transition-colors shrink-0",
            checked
              ? "bg-[#0a68ff] border-[#0a68ff]"
              : "bg-white border-gray-30 group-hover:border-gray-400",
            error && !checked && "border-[#ff424f]" // Turn border red on error
          )}
        >
          {checked && <Icons.TickIcon className="text-white w-3 h-3" />}
        </div>

        {/* Label */}
        {label && (
          <span className="text-sm font-normal text-gray-100 leading-6">
            {label}
          </span>
        )}
      </div>

      {/* Error Message */}
      {error && (
        <p className="text-xs text-[#ff424f]">{error}</p>
      )}
    </div>
  );
});

Checkbox.displayName = "Checkbox";